/**
 * @description sessionStorageに施設id格納,各施設cms読み込みに使用
 */

import { getData } from './getData';
// import { getSiteId } from './getSiteId';
import { existsMultiLanguage } from './existsMultiLanguage';

export const setid = async () => {
  //いまのところ多言語はcms読み込みなしのため
  if (existsMultiLanguage()) return;
  const pathList = location.pathname.split('/');
  if (pathList[1] === sessionStorage.getItem('name')) return;

  let id: number;
  const getResponse = async () => {
    const url = [`${location.origin}/wp-json/wp/v2/facility_name?per_page=64`];
    return await Promise.all(url.map(getData));
  };

  return await getResponse().then((res) => {
    const data = res[0].data;
    for (const d of data) {
      if (pathList[1] == d.slug) id = d.id;
    }
    sessionStorage.setItem('id', `${id}`);
    sessionStorage.setItem('name', pathList[1]);
  });
};
